import { render, staticRenderFns } from "./changeNeed.vue?vue&type=template&id=16852eea&scoped=true&"
import script from "./changeNeed.vue?vue&type=script&lang=js&"
export * from "./changeNeed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16852eea",
  null
  
)

export default component.exports